const serviceCognitoV4 = [
  /* 14-12-2023 */
  '/manage/pnr',
  '/manage/ancillaries',
  '/manage/seatmaps',
  '/manage/seatmaps/preSelectSeat',
  '/manage/meal/menu',
  '/manage/meal/select',
  '/manage/carts',
  '/manage/updateCartId',
  '/manage/addBagByBenefit',
  '/manage/payment-methods',
  '/manage/po',
  '/manage/email-receipt',
  '/manage/emdVoucher/validate',
  '/manage/emdVoucher/remove',
  '/manage/change-status',
  '/manage/ancillaries/chubb',
  '/irops/pnrlookup/iropEligibility',
  '/prioritylist',
  /* 09-01-2023 */
  '/validate/session',
  '/profile/user-profile-trips',
  '/profile/user-profile-createAccount',
  '/profile/user-profile-sign-in',
  '/profile/user-profile-sign-out',
  '/profile/user-profile-valid-session',
  '/enrollment/validate-email',
  '/enrollment/validate-tutor',
  '/enrollment/otp/sendcode',
  '/enrollment/otp/verifycode',
  '/enrollment/user-registration',
  '/enrollment/validate-email',
  '/enrollment/validate-tutor',
  '/enrollment/otp/sendcode',
  '/enrollment/otp/verifycode',
  '/enrollment/user-registration',
  /* 06-02-2023 */
  '/ffn-association',
  /* 01-04-2024 */
  '/clubPremier/update-consent',
  '/clubPremier/campaign/member-enrolled',
  '/clubPremier/sessionTM',
  '/app/clubPremier/resend-otp',
  '/contactability/digital',
  '/contactability/token',
];

export default serviceCognitoV4;
// nuevos servicios que pasan por el token de cognito y canal v4